import Modal from 'developer_components/newModal';
import Step from './authorization-modal/steps/step';
import InitialStep from './authorization-modal/steps/initial-step';
import AuthTypeTourist from './authorization-modal/auth-type-tourist';
import AuthTypeHotel from './authorization-modal/auth-type-hotel';
import {loadScript} from 'methods/utils';

function AuthorizationModal(options = {}) {
    // singleton
    if (window.__AuthorizationModalInstance) {
        return window.__AuthorizationModalInstance;
    }
    window.__AuthorizationModalInstance = this;

    const className = 'Authorization';
    const $element = Modal.createFromHTML(
        `<div class="${className}">
            <div class="${className}__header">
                <div class="${className}__back js-back" title="Вернуться назад">
                    <button type="button">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289Z" fill="#2A2536"/>
                        </svg>
                        <span>Назад</span>
                    </button>
                </div>
                <div class="${className}__close js-close" title="Закрыть">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.307 7.69289C16.6976 8.08342 16.6976 8.71658 16.307 9.10711L13.4142 12L16.307 14.8929C16.6976 15.2834 16.6976 15.9166 16.307 16.3071C15.9165 16.6976 15.2834 16.6976 14.8928 16.3071L11.9999 13.4142L9.10705 16.3071C8.71653 16.6976 8.08336 16.6976 7.69284 16.3071C7.30231 15.9166 7.30231 15.2834 7.69284 14.8929L10.5857 12L7.69284 9.10711C7.30231 8.71658 7.30231 8.08342 7.69284 7.69289C8.08336 7.30237 8.71653 7.30237 9.10705 7.69289L11.9999 10.5858L14.8928 7.69289C15.2834 7.30237 15.9165 7.30237 16.307 7.69289Z" fill="#2A2536"/>
                    </svg>
                </div>
            </div>
            <div class="${className}__body">
                <div class="${className}__title js-title"></div>
                <div class="${className}__step js-step"></div>
            </div>
            <div class="${className}__footer js-footer"></div>
        </div>`,
    );

    Modal.call(this, $element, options);

    this.className = className;
    this.canPrevStep = true;

    this.$back = this.$element.querySelector('.js-back');
    this.$back.addEventListener('click', this.prevStep.bind(this));

    this.$close = this.$element.querySelector('.js-close');
    this.$close.addEventListener('click', this.close.bind(this));

    this.$title  = this.$element.querySelector('.js-title');
    this.$step   = this.$element.querySelector('.js-step');
    this.$footer = this.$element.querySelector('.js-footer');

    this.authTypes = [
        new AuthTypeTourist(this),
        new AuthTypeHotel(this),
    ];
}

AuthorizationModal.prototype = Object.create(Modal.prototype);
Object.defineProperty(AuthorizationModal.prototype, 'constructor', {
    value: AuthorizationModal,
    enumerable: false,
    writable: true,
});

/**
 * Авторизация.
 *
 * @param {String} type Имя авторизации
 * @param {Object} data Параметры
 *
 * @return {Promise} auth
 */
AuthorizationModal.prototype.auth = function(type, data) {
    let auth;

    // универсальная авторизация
    if (typeof type == 'undefined') {
        auth = this.init().auth();
    }

    // конкретная авторизация (отельер / турист)
    else {
        const step = this.getAuthTypeByName(type);

        this.hideCurrentStep();
        delete step.prevStep;

        auth = step.auth(data);
    }

    return auth.finally(() => {
        this.close();
    });
}

/**
 * Проверка авторизации.
 *
 * @param {String} type Имя авторизации
 *
 * @return {Promise} auth
 */
AuthorizationModal.prototype.authorized = function(type) {
    return this.getAuthTypeByName(type).authorized();
}

AuthorizationModal.prototype.init = function() {
    return this.showStep(new InitialStep(this));
}

AuthorizationModal.prototype.getAuthTypeByName = function(name) {
    return this.authTypes.find(authType => authType.name == name);
}

AuthorizationModal.prototype.hideCurrentStep = function() {
    if (typeof this.step != 'undefined') {
        this.step.hide();
        this.step.$element.remove();
        delete this.step;
    }
}

AuthorizationModal.prototype.showStep = function(step, isBack = false) {
    if (!(step instanceof Step)) {
        throw new TypeError('step must be a Step instance');
    }

    if (typeof step.prevStep == 'undefined') {
        step.prevStep = this.step;
    }

    this.hideCurrentStep();
    this.resetFooterContent();

    this.step = step;
    this.$step.appendChild(this.step.$element);

    if (this.isOpened()) {
        this.step.$element.animate([
            {transform: `translateX(${10 * (isBack ? -1 : 1)}px)`, opacity: 0, easing: 'ease-in-out'},
            {transform: 'translateX(0px)', opacity: 1, easing: 'ease-in-out'},
        ], 100);
    }

    this.initGoogleCaptcha();
    this.open();
    this.step.show();
    this.$back.classList.toggle('is-visible', typeof this.step.prevStep != 'undefined' && this.step.canPrevStep);

    return this.step;
}

AuthorizationModal.prototype.prevStep = function() {
    this.step.back();
    this.showStep(this.step.prevStep, true);
}

AuthorizationModal.prototype.setTitle = function(title) {
    this.$title.textContent = title;
}

AuthorizationModal.prototype.setCanPrevStep = function(value) {
    this.$back.classList.toggle('is-visible', this.canPrevStep = !!value);
}

AuthorizationModal.prototype.resetFooterContent = function() {
    while (this.$footer.lastChild) {
        this.$footer.removeChild(this.$footer.lastChild);
    }
}

AuthorizationModal.prototype.setFooterContent = function($element) {
    this.resetFooterContent();
    this.$footer.appendChild($element);
}

AuthorizationModal.prototype.initGoogleCaptcha = function() {
    if (!this._googleCaptcha) {
        this._googleCaptcha = loadScript(`https://www.google.com/recaptcha/api.js`);
    }

    return this._googleCaptcha;
}

export default AuthorizationModal;
